
import useResponsiveFlags from '../hooks/useResponsiveFlags';
import useLanguage from '../hooks/useLanguage';

import styles from '../assets/styles/Highlight.module.css';
import { translations } from '../locales/lang';


export default function HighlightSection() {
    const { language } = useLanguage();
    const features = [
        {
            title: translations[language].highlight.features.first.title,
            image: (
                <div className={styles.featureImage}>
                    <img
                        className={styles.firstImage}
                        src='/images/feature/picture-1.png' alt="picture-1"
                        data-aos="fade-right"
                        data-aos-delay="600"
                    />
                    <img
                        className={styles.secondImage}
                        src='/images/feature/picture-2.png' alt="picture-2"
                        data-aos="fade-right"
                        data-aos-delay="700"
                    />
                </div>
            ),
            isShow: true,
            itemDetails: [
                {
                    image: '/images/feature/icon-7.svg',
                    content: translations[language].highlight.features.first.itemDetails[0].content
                },
                {
                    image: '/images/feature/icon-8.svg',
                    content: translations[language].highlight.features.first.itemDetails[1].content
                },
                {
                    image: '/images/feature/icon-9.svg',
                    content: translations[language].highlight.features.first.itemDetails[2].content
                },
                {
                    image: '/images/feature/icon-10.svg',
                    content: translations[language].highlight.features.first.itemDetails[3].content
                },
            ]
        },
        {
            title: translations[language].highlight.features.second.title,
            description: translations[language].highlight.features.second.description,
            image: (
                <div className={styles.featureImage}>
                    <img
                        className={styles.thirdImage}
                        src='/images/feature/picture-3.png' alt="picture-3"
                        data-aos="fade-right"
                    // data-aos-delay="900"
                    />
                    {/* <img
                    className={styles.fourImage}
                    src='/images/feature/picture-4.png' alt="picture-4"
                    data-aos="fade-right"
                /> */}
                </div>
            ),
            isShow: false
        },
        {
            title: translations[language].highlight.features.third.title,
            description: translations[language].highlight.features.third.description,
            image: (
                <div className={styles.featureImage}>
                    <img
                        className={styles.fiveImage}
                        src='/images/feature/picture-5.png' alt="picture-5"
                        data-aos="fade-left"
                    />
                    <img
                        className={styles.sixImage}
                        src='/images/feature/picture-6.png' alt="picture-6"
                        data-aos="fade"
                        data-aos-delay="800"
                    />
                    <img
                        className={styles.sevenImage}
                        src='/images/feature/picture-7.png' alt="picture-7"
                        data-aos="fade"
                        data-aos-delay="700"
                    />
                </div>
            ),
            isShow: true
        },
        {
            title: translations[language].highlight.features.four.title,
            description: translations[language].highlight.features.four.description,
            image: (
                <div className={styles.featureImage}>
                    <img
                        className={styles.eightImage}
                        src='/images/feature/picture-8.png' alt="picture-8"
                        data-aos="fade-right"
                    />
                    <img
                        className={styles.nineImage}
                        src='/images/feature/picture-9.png' alt="picture-9"
                        data-aos="fade"
                        data-aos-delay="600"
                    />
                    <img
                        className={styles.tenImage}
                        src='/images/feature/picture-10.png' alt="picture-10"
                        data-aos="fade"
                        data-aos-delay="700"
                    />
                </div>
            ),
            isShow: false
        },
        {
            title: translations[language].highlight.features.five.title,
            description: translations[language].highlight.features.five.description,
            image: (
                <div className={styles.featureImage}>
                    <img
                        className={styles.elevenImage}
                        src='/images/feature/picture-11.png' alt="picture-11"
                        data-aos="fade-left"
                    />
                    <img
                        className={styles.twelveImage}
                        src='/images/feature/picture-12.png' alt="picture-12"
                        data-aos="fade"
                        data-aos-delay="700"
                    />
                </div>
            ),
            isShow: false
        },
        {
            title: translations[language].highlight.features.six.title,
            description: translations[language].highlight.features.six.description,
            image: (
                <div className={styles.featureImage}>
                    <img
                        className={styles.thirdteenImage}
                        src='/images/feature/picture-13.png' alt="picture-13"
                        data-aos="fade-right"
                    />
                    <img
                        className={styles.fourteenImage}
                        src='/images/feature/picture-14.png' alt="picture-14"
                        data-aos="fade"
                        data-aos-delay="700"
                    />
                    <img
                        className={styles.fifteenImage}
                        src='/images/feature/picture-15.png' alt="picture-15"
                        data-aos="fade"
                        data-aos-delay="700"
                    />
                </div>
            ),
            isShow: false
        }
    ];

    const { isMobile, isTablet } = useResponsiveFlags();


    return (
        <section className={styles.section} id='feature'>
            <h2 className={styles.title}>{translations[language].highlight.title}</h2>
            <div className={styles.wrapper}>
                {features.map((item, index) => (
                    <div
                        key={index}
                        className={`${styles.featureItem} ${index === 0 || index === 1 || index % 2 === 1 ? styles.left : styles.right
                            }`}
                    >
                        {item.isShow && <div className={styles.shapeBackground} data-aos={index === 0 ? 'fade-right' : 'fade-left'} />}
                        {index === 4 && <div className={styles.shapeOrange} data-aos='fade-left' />}
                        {index === 3 && <div className={styles.shapeGreen} data-aos='fade-right' />}
                        <div className={styles.imageContainer} >
                            {(isMobile || isTablet) && index === 0 && (
                                <div
                                    className={styles.mobileTitle}
                                    dangerouslySetInnerHTML={{ __html: item.title }}
                                    data-aos="fade-down"
                                />
                            )}
                            {item.image}
                        </div>
                        <div className={styles.textContent} style={index !== 0 ? {} : { gap: '28px' }}>
                            <div
                                dangerouslySetInnerHTML={{ __html: item.title }}
                                className={`${styles.textContentTitle} ${index === 5 ? styles.lastItemTitle : ''} ${index === 0 ? styles.hideTitleOnMobile : ''}`}
                                data-aos={index === 0 || index === 1 || index % 2 === 1 ? 'fade-left' : 'fade-right'}>
                            </div>
                            {item.description &&
                                <p
                                    style={{ letterSpacing: '1px' }}
                                    className={`${styles.textContentDescription} ${index === 5 ? styles.lastItem : ''}`}
                                    data-aos={index === 0 || index === 1 || index % 2 === 1 ? 'fade-left' : 'fade-right'}
                                // data-aos-delay={600}
                                >
                                    {item?.description}
                                </p>}
                            {
                                item.itemDetails &&
                                <div className={styles.itemDetails}>
                                    {
                                        item.itemDetails.map((item, index) => (
                                            <div
                                                key={index}
                                                className={
                                                    `${styles.itemDetail}
                                                 ${index === 0 ? styles.firstItem : index === 1 ? styles.secondItem : index === 2 ? styles.thirdItem : styles.fourthItem}`
                                                }
                                                data-aos='fade-left'
                                                data-aos-delay={(index + 1) * 100}
                                            >
                                                <img src={item.image} alt={item.content} />
                                                <p>{item.content}</p>
                                            </div>
                                        ))
                                    }
                                </div>
                            }
                        </div>
                    </div>
                ))}
            </div>
            <div className={styles.bottomBgr} />
        </section >
    );
}
